import useAuthSystem from '../new_arch/modules/authentication/system/useAuthSystem';

const useIsLoggedIn = () => {
	const authSystem = useAuthSystem();
	return authSystem.isAuthenticated;
}

export default useIsLoggedIn;
